import React from "react";

import { useFormikContext } from "formik";
import { Grid } from "@material-ui/core";
import Development from "components/development";
import { CodeBlock } from "./value-debugger";

const ValidationDebugger: React.FC = () => {
  const { errors } = useFormikContext();

  return (
    <Development>
      <Grid container>
        <CodeBlock title="All Validation Errors" code={JSON.stringify(errors, null, 2)}/>
      </Grid>
    </Development>
  );
};

export default ValidationDebugger;
